import { Avatar } from "@/atoms";
import type { AlfredAvatarPropsInterface } from "@/interfaces/alfred";
import { generateValidClassNameHandler } from "@/lib/utils";

const sizeClasses = {
    lg: "size-12",
    md: "size-8",
    sm: "size-6",
};

/**
 * AlfredAvatar - Avatar component for Alfred AI assistant
 * Uses the base Avatar atom with Alfred-specific styling
 */
export const AlfredAvatar = ({
    className,
    isGenerating = false,
    showBadge = false,
    size = "md",
}: AlfredAvatarPropsInterface) => (
    <div className="relative">
        <Avatar
            className={generateValidClassNameHandler(
                "bg-gradient-to-br from-purple-500 to-indigo-600",
                sizeClasses[size],
                isGenerating && "animate-pulse",
                className,
            )}
        >
            <span className="text-xs font-semibold text-white">A</span>
        </Avatar>
        {showBadge && (
            <span className="absolute -bottom-0.5 -right-0.5 size-3 rounded-full bg-green-500 ring-2 ring-white" />
        )}
    </div>
);
